var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 18,
  fill: "#5F2698",
  viewBox: "0 0 24 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.108 15.917V.747a.6.6 0 1 0-1.2 0v15.185l-3.518-3.127a.6.6 0 0 0-.797.896l4.5 4a.6.6 0 0 0 .407.152.6.6 0 0 0 .407-.152l4.5-4a.6.6 0 1 0-.797-.896zM5.068.323A.6.6 0 0 1 5.5.148a.6.6 0 0 1 .432.175l4.5 4.5a.6.6 0 1 1-.848.849L6.108 2.196v15.057a.6.6 0 0 1-1.2 0V2.18L1.416 5.672a.6.6 0 0 1-.849-.849z",
  clipRule: "evenodd"
})));
export { SvgReorder as ReactComponent };